module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT Kindergarten-8fa95d1d40b48e006716905e8f00c678.gif";